import { useState } from "react";
import axios from "axios";
import { API, getAuthHeader } from "@/App";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { FlaskConical, Eye, EyeOff, FileSpreadsheet, Loader2, Lock } from "lucide-react";

// Admin-only: Raw / API / bulk-weight products hidden from the team procure list.
export const RawApiProcure = ({ params, onDownload, busy }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const view = async () => {
    if (data) { setData(null); return; }
    setLoading(true);
    try {
      const r = await axios.get(`${API}/order-register/pending-center/procure`,
        { headers: getAuthHeader(), params: { ...params(), fmt: "raw_api_json" } });
      setData(r.data);
    } catch (e) { toast.error(e.response?.data?.detail || "Could not load Raw API list"); }
    setLoading(false);
  };

  return (
    <div className="rounded-lg border border-rose-200 bg-rose-50/40 p-3 space-y-2 md:col-span-3" data-testid="pc-raw-api">
      <div className="flex items-center gap-2 text-xs font-semibold text-rose-800">
        <FlaskConical className="w-4 h-4" /> Raw API — owner procurement
        <span className="ml-1 inline-flex items-center gap-1 rounded-full bg-rose-100 border border-rose-200 px-1.5 text-[10px]">
          <Lock className="w-3 h-3" /> admin only
        </span>
      </div>
      <p className="text-[11px] text-slate-500">Raw / API / any kg·kilo·kilogram / gms·gram·grams products — hidden from the team's Procure list &amp; Shriram Orders.</p>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" className="border-rose-300 text-rose-700 hover:bg-rose-50" onClick={view}
          disabled={loading} data-testid="pc-raw-api-view">
          {loading ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : data ? <EyeOff className="w-4 h-4 mr-1" /> : <Eye className="w-4 h-4 mr-1" />}
          {data ? "Hide" : "View on screen"}
        </Button>
        <Button size="sm" variant="outline" className="border-rose-300 text-rose-700 hover:bg-rose-50" disabled={!!busy}
          onClick={() => onDownload("procure", { fmt: "raw_api" }, "raw-api-excel")} data-testid="pc-raw-api-excel">
          {busy === "raw-api-excel" ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <FileSpreadsheet className="w-4 h-4 mr-1" />} Excel
        </Button>
      </div>
      {data && (
        <div className="max-h-64 overflow-auto rounded border bg-white" data-testid="pc-raw-api-table">
          <table className="w-full text-xs">
            <thead className="bg-rose-50 sticky top-0">
              <tr className="text-left text-rose-900">
                <th className="p-1.5">Code</th><th className="p-1.5">Product / Medicine</th>
                <th className="p-1.5">Second Name</th><th className="p-1.5 text-right">Total Qty</th><th className="p-1.5 text-right">Parcels</th>
              </tr>
            </thead>
            <tbody>
              {data.items.length === 0 && (
                <tr><td colSpan={5} className="p-3 text-center text-slate-400" data-testid="pc-raw-api-empty">No Raw API products pending in this scope</td></tr>
              )}
              {data.items.map((a, i) => (
                <tr key={i} className="border-t" data-testid={`pc-raw-api-row-${i}`}>
                  <td className="p-1.5 font-mono">{a.code}</td><td className="p-1.5">{a.medicine}</td>
                  <td className="p-1.5 text-slate-500">{a.second}</td>
                  <td className="p-1.5 text-right font-semibold">{a.qty}</td><td className="p-1.5 text-right">{a.parcels}</td>
                </tr>
              ))}
              {data.items.length > 0 && (
                <tr className="border-t bg-rose-50 font-semibold" data-testid="pc-raw-api-total">
                  <td className="p-1.5" colSpan={3}>TOTAL</td>
                  <td className="p-1.5 text-right">{data.total_qty}</td><td className="p-1.5 text-right">{data.parcels}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
